var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGcFilterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90186 2.53237C1.90186 2.18226 2.18568 1.89844 2.53579 1.89844H12.6787C13.0288 1.89844 13.3126 2.18226 13.3126 2.53237V4.17158C13.3126 4.33971 13.2458 4.50095 13.1269 4.61984L9.06078 8.68601C8.94189 8.80489 8.8751 8.96614 8.8751 9.13427V10.7735L6.33938 13.3092V9.13427C6.33938 8.96614 6.27259 8.80489 6.1537 8.68601L2.08753 4.61984C1.96864 4.50095 1.90186 4.33971 1.90186 4.17158V2.53237Z",
    stroke: "#21314B",
    strokeWidth: 1.26786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcFilterIcon);
export default __webpack_public_path__ + "static/media/GCFilterIcon.ed227e6737efce06dc162fa40d944437.svg";
export { ForwardRef as ReactComponent };